module.exports = __webpack_public_path__ + "img/scratch_all_works.628be99a.svg";